import { RenderModule } from "../wasm/MelcoRendererApp";

export class LocalFileInterface {
    public constructor(module: RenderModule) {
        this._module = module
    }
    public async ensureIDBFSMounted(): Promise<boolean> {
        if (!this._idbfsMounted) {
            if (!this._idbfsPromise) {
                let resolve: (v: boolean) => void
                let reject: (v?: string) => void
                const promise = new Promise<boolean>((res, rej) => {
                    resolve = res;
                    reject = rej;
                });
                this._idbfsPromise = promise
                this._module.FS.mkdir('/data')
                this._module.FS.mount(IDBFS, {}, '/data')
                this._module.FS.syncfs(true, (err) => {
                    this._idbfsMounted = true
                    this._idbfsPromise = undefined
                    if (err) {
                        reject("Failed to mount")
                    } else {
                        resolve(true)
                    }
                })
            }
            if (this._idbfsPromise) {
                return this._idbfsPromise
            }
        }
        return Promise.resolve(true)
    }
    public writeToFile(data: Uint8Array, filename: string, permanent: boolean = false) {
        let prefix = "/"
        if (permanent) {
            prefix = "/data/"
        }
        let writeTo = prefix + filename
        this._module.FS.writeFile(writeTo, data)
        return 'file://' + writeTo
    }
    public async syncFileAfterWriteToPermanent(): Promise<boolean> {
        let resolve: (v: boolean) => void
        let reject: (v?: string) => void
        const promise = new Promise<boolean>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        this._module.FS.syncfs(false, (err) => {
            if (err) {
                reject("Failed to sync")
            } else {
                resolve(true)
            }
        })
        return promise
    }
    private _module: RenderModule
    private _idbfsMounted: boolean = false
    private _idbfsPromise?: Promise<boolean>
}